import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { PrimitiveClasses_getInstance6p7zmos9nw3c as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  getStarKTypeProjection316vzroubdy0t as getStarKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instanceoz9dr731l81q as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  get_HttpRequestIsReadyForSending2qftypei374ml as get_HttpRequestIsReadyForSending,
  get_HttpResponseReceived23ai4hzotyx3a as get_HttpResponseReceived,
  get_HttpResponseCancelled3685lnxbzknld as get_HttpResponseCancelled,
} from '../utils/ClientEvents.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Key_instance17dpgmdbeabno as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { KtorCallContextElementudwxlrp3zgdl as KtorCallContextElement } from './Utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ClientEngineClosedException1qtw9cl0kd5fk as ClientEngineClosedException } from './HttpClientEngineBase.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Phases_getInstance16mtoo1oa3tq as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeaders_getInstance1z5nmwg0t7mku as HttpHeaders_getInstance,
  UnsafeHeaderException3ncvrrp48xjzq as UnsafeHeaderException,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpHeaders.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from '../HttpClientConfig.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CALL_COROUTINE() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CALL_COROUTINE;
}
var CALL_COROUTINE;
function get_CLIENT_CONFIG() {
  _init_properties_HttpClientEngine_kt__h91z5h();
  return CLIENT_CONFIG;
}
var CLIENT_CONFIG;
function *_generator_invoke__zhh2q8($this, $this$intercept, content, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpRequestBuilder())();
  this_0.e5l($this$intercept.m4r_1);
  // Inline function 'io.ktor.client.request.setBody' call
  if (content == null) {
    this_0.u5g_1 = NullBody_instance;
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = PrimitiveClasses_getInstance().vf();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(PrimitiveClasses_getInstance().vf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$0);
    this_0.f5l(tmp$ret$1);
  } else {
    if (content instanceof OutgoingContent()) {
      this_0.u5g_1 = content;
      this_0.f5l(null);
    } else {
      this_0.u5g_1 = content;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = PrimitiveClasses_getInstance().vf();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(PrimitiveClasses_getInstance().vf(), arrayOf([]), false);
      } catch ($p) {
        var tmp_4;
        if ($p instanceof Error) {
          var _unused_var__etf5q3_0 = $p;
          tmp_4 = null;
        } else {
          throw $p;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$2 = tmp_3;
      var tmp$ret$3 = new (TypeInfo())(tmp_2, tmp$ret$2);
      this_0.f5l(tmp$ret$3);
    }
  }
  var builder = this_0;
  $this.g5l_1.g5g_1.s4s(get_HttpRequestIsReadyForSending(), builder);
  // Inline function 'kotlin.apply' call
  var this_1 = builder.n37();
  this_1.n5l_1.x4m(get_CLIENT_CONFIG(), $this.g5l_1.h5g_1);
  var requestData = this_1;
  validateHeaders(requestData);
  checkExtensions($this.h5l_1, requestData);
  var tmp_5 = executeWithinCallContext($this.h5l_1, requestData, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var responseData = tmp_5;
  var call = HttpClientCall().t5j($this.g5l_1, requestData, responseData);
  var response = call.o5g();
  $this.g5l_1.g5g_1.s4s(get_HttpResponseReceived(), response);
  var tmp_6 = get_job(response.ew());
  tmp_6.hx((it) => {
    var tmp;
    if (!(it == null)) {
      $this.g5l_1.g5g_1.s4s(get_HttpResponseCancelled(), response);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var tmp_7 = $this$intercept.o4q(call, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  return Unit_instance;
}
function _get_closed__iwkfs1($this) {
  var tmp0_safe_receiver = $this.ew().hd(Key_instance);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fw();
  return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
function *_generator_executeWithinCallContext__cpuknr($this, requestData, $completion) {
  var tmp = createCallContext($this, requestData.m5l_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var callContext = tmp;
  var context = callContext.om(new (KtorCallContextElement())(callContext));
  var tmp_0 = async($this, context, VOID, HttpClientEngine$executeWithinCallContext$slambda_0($this, requestData)).yy($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function executeWithinCallContext($this, requestData, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_executeWithinCallContext__cpuknr.bind(VOID, $this, requestData), $completion);
}
function checkExtensions($this, requestData) {
  var _iterator__ex2g4s = requestData.o5l_1.u1();
  while (_iterator__ex2g4s.v1()) {
    var requestedExtension = _iterator__ex2g4s.w1();
    // Inline function 'kotlin.require' call
    if (!$this.p5l().y2(requestedExtension)) {
      var message = "Engine doesn't support " + toString(requestedExtension);
      throw IllegalArgumentException().s2(toString(message));
    }
  }
}
var HttpClientEngine$install$slambdaClass;
function HttpClientEngine$install$slambda() {
  if (HttpClientEngine$install$slambdaClass === VOID) {
    class $ {
      constructor($client, this$0) {
        this.g5l_1 = $client;
        this.h5l_1 = this$0;
      }
      x5g($this$intercept, content, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, content), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.x5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpClientEngine$install$slambdaClass = $;
  }
  return HttpClientEngine$install$slambdaClass;
}
function HttpClientEngine$install$slambda_0($client, this$0) {
  var i = new (HttpClientEngine$install$slambda())($client, this$0);
  var l = ($this$intercept, content, $completion) => i.x5g($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
var HttpClientEngine$executeWithinCallContext$slambdaClass;
function HttpClientEngine$executeWithinCallContext$slambda() {
  if (HttpClientEngine$executeWithinCallContext$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $requestData) {
        this.q5l_1 = this$0;
        this.r5l_1 = $requestData;
      }
      c1g($this$async, $completion) {
        if (_get_closed__iwkfs1(this.q5l_1)) {
          throw ClientEngineClosedException().x5l();
        }
        return this.q5l_1.y5l(this.r5l_1, $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpClientEngine$executeWithinCallContext$slambdaClass = $;
  }
  return HttpClientEngine$executeWithinCallContext$slambdaClass;
}
function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData) {
  var i = new (HttpClientEngine$executeWithinCallContext$slambda())(this$0, $requestData);
  var l = ($this$async, $completion) => i.c1g($this$async, $completion);
  l.$arity = 1;
  return l;
}
function get_supportedCapabilities() {
  return emptySet();
}
function install(client) {
  var tmp = Phases_getInstance().f5h_1;
  client.c5g_1.q4r(tmp, HttpClientEngine$install$slambda_0(client, this));
}
var HttpClientEngineClass;
function HttpClientEngine() {
  if (HttpClientEngineClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpClientEngine', VOID, VOID, [CoroutineScope(), AutoCloseable()], [1]);
    HttpClientEngineClass = $;
  }
  return HttpClientEngineClass;
}
function validateHeaders(request) {
  _init_properties_HttpClientEngine_kt__h91z5h();
  var requestHeaders = request.k5l_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = requestHeaders.p4o();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().u2();
  var _iterator__ex2g4s = tmp0.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (HttpHeaders_getInstance().m4z_1.y2(element)) {
      destination.n2(element);
    }
  }
  var unsafeRequestHeaders = destination;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!unsafeRequestHeaders.s1()) {
    throw UnsafeHeaderException().k50(toString(unsafeRequestHeaders));
  }
}
function createCallContext(_this__u8e3s4, parentJob, $completion) {
  var callJob = Job(parentJob);
  var callContext = _this__u8e3s4.ew().om(callJob).om(get_CALL_COROUTINE());
  $l$block: {
    // Inline function 'io.ktor.client.engine.attachToUserJob' call
    var callJob_0 = callJob;
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp0_elvis_lhs = $completion.rc().hd(Key_instance);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var userJob = tmp;
    var cleanupHandler = userJob.jx(true, VOID, (cause) => {
      if (cause == null)
        return Unit_instance;
      callJob_0.ox(CancellationException().n(cause.message));
      return Unit_instance;
    });
    callJob_0.hx((it) => {
      cleanupHandler.vz();
      return Unit_instance;
    });
  }
  return callContext;
}
var properties_initialized_HttpClientEngine_kt_5uiebb;
function _init_properties_HttpClientEngine_kt__h91z5h() {
  if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
    properties_initialized_HttpClientEngine_kt_5uiebb = true;
    CALL_COROUTINE = new (CoroutineName())('call-context');
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'client-config';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(HttpClientConfig());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(HttpClientConfig()), arrayOf([getStarKTypeProjection()]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$0);
    CLIENT_CONFIG = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: exports
export {
  get_CLIENT_CONFIG as get_CLIENT_CONFIG1oazdiwjd1qe0,
  install as install34ed8l0uhurm0,
  get_supportedCapabilities as get_supportedCapabilities36x6e2ixit204,
  HttpClientEngine as HttpClientEngine3f41d0b7i209y,
};
//endregion

//# sourceMappingURL=HttpClientEngine.mjs.map
